import React from "react";
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin, Youtube, ArrowRight } from "lucide-react";
import { COMPANY, NAV_LINKS, SERVICES } from "../mock";
import { LogoWordmark } from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="lg:col-span-1">
          <LogoWordmark height={44} inverted />
          <p className="mt-5 text-sm leading-relaxed text-slate-400">
            {COMPANY.fullName} (NRC) — a specialist contractor for metal roofing, false ceilings, under-deck insulation, suspended grid ceilings, acoustic ceilings and roof & wall cladding.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 px-3 py-2 bg-yellow-700/10 border border-yellow-700/30 rounded text-yellow-500 text-xs font-bold tracking-wider uppercase">
            <span className="w-1.5 h-1.5 bg-yellow-600 rounded-full" /> Hunter Douglas Partner
          </div>
        </div>

        <div>
          <h4 className="text-white font-bold uppercase tracking-wider text-sm">Quick Links</h4>
          <ul className="mt-5 space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.label}>
                <a href={l.href} className="text-sm text-slate-400 hover:text-yellow-600 inline-flex items-center gap-2 group">
                  <ArrowRight className="w-3.5 h-3.5 text-yellow-700 group-hover:translate-x-1 transition-transform" />
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold uppercase tracking-wider text-sm">Services</h4>
          <ul className="mt-5 space-y-2.5">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <a href="#services" className="text-sm text-slate-400 hover:text-yellow-600 inline-flex items-center gap-2 group">
                  <ArrowRight className="w-3.5 h-3.5 text-yellow-700 group-hover:translate-x-1 transition-transform" />
                  {s.title}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold uppercase tracking-wider text-sm">Reach Us</h4>
          <ul className="mt-5 space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-yellow-600 shrink-0" />
              <span className="text-slate-400 leading-relaxed">{COMPANY.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-yellow-600" />
              <a href={`tel:${COMPANY.phone.replace(/\s+/g, "")}`} className="text-slate-300 hover:text-yellow-600">{COMPANY.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-yellow-600" />
              <a href={`mailto:${COMPANY.email}`} className="text-slate-300 hover:text-yellow-600">{COMPANY.email}</a>
            </li>
          </ul>
          <div className="mt-6 flex items-center gap-2">
            {[Facebook, Instagram, Linkedin, Youtube].map((Ic, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full bg-slate-800 hover:bg-yellow-700 grid place-items-center text-slate-300 hover:text-white transition-colors">
                <Ic className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-yellow-600">Privacy Policy</a>
            <a href="#" className="hover:text-yellow-600">Terms of Service</a>
            <a href="#" className="hover:text-yellow-600">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
